import {Fragment, useEffect, useMemo} from 'react';
import {useTranslation} from 'react-i18next';

import {groupApi, sessionResultInformationApi} from 'api';
import {DataWrapper, PageHeader, Tab, Tabs} from 'components';
import {useApiData} from 'hooks';
import {TRANSLATION_KEYS} from 'locale/translation-keys';
import {userAuthUtils} from 'utils';

import {SessionResultInformationValues} from './SessionResultInformationValues';

const T_KEYS = TRANSLATION_KEYS.USER.CONTENT.SESSION_RESULT;

export const SessionResult: React.FC = () => {
    const {t} = useTranslation();

    const {send: loadGroups, data: groups, loading: groupsLoading} = useApiData(groupApi.getGroups, {loadingDefault: true});

    const {successInformation, rejectInformation} = useMemo(() =>
        userAuthUtils.getUserPermissions().content.sessionResult, []);

    useEffect(() => {
        loadGroups();
    }, [loadGroups]);

    return (
        <Fragment>
            <PageHeader title={t(T_KEYS.TITLE)} description={t(T_KEYS.DESCRIPTION)} />
            <DataWrapper isLoading={groupsLoading}>
                <Tabs>
                    <Tab name={t(T_KEYS.TABS.REJECT)} hidden={!rejectInformation?.enabled}>
                        <SessionResultInformationValues
                            groups={groups}
                            fetchData={sessionResultInformationApi.getFailedSessionResultValues}
                            saveData={sessionResultInformationApi.saveFailedSessionResultValues}
                        />
                    </Tab>
                    <Tab name={t(T_KEYS.TABS.SUCCESS)} hidden={!successInformation?.enabled}>
                        <SessionResultInformationValues
                            groups={groups}
                            fetchData={sessionResultInformationApi.getSuccessSessionResultValues}
                            saveData={sessionResultInformationApi.saveSuccessSessionResultValues}
                        />
                    </Tab>
                </Tabs>
            </DataWrapper>
        </Fragment>
    );
};